export interface VideoTutorialesInterface{
    nombre:string
    link:string
}

export const videosAdministrador: VideoTutorialesInterface[]=[
    {
        nombre:'Crear nuevos usuarios',
        link:'https://drive.google.com/file/d/1Nm8yeAoy6aUCyT_2GNUrfEfH9pEaXJm7/view?usp=drive_link'
    },
    {
        nombre:'Cambiar contraseña de usuario',
        link:'https://drive.google.com/file/d/1dgeINIaICz1kSTWch07aP64w37aFLfZd/view?usp=drive_link'
    },
    {
        nombre:'Actualizar información del usuario',
        link:'https://drive.google.com/file/d/1ubqr8_kMmuBexENXjyNM88NsHBiZUKbO/view?usp=drive_link'
    },
    {
        nombre:'Crear un Rol',
        link:'https://drive.google.com/file/d/1SlJ_jt5qHiE6Zrle51DbkeOqmN9ObgD9/view?usp=drive_link'
    },
    {
        nombre:'Editar Roles y Permisos',
        link:'https://drive.google.com/file/d/1GSewSCA5Vv5zR2P-Q8x91zUfG1RIPYlZ/view?usp=sharing'
    },
]

export const videosSolicitudes: VideoTutorialesInterface[]=[
    {
        nombre:'Ver y Asignar Usuarios a una solicitud',
        link:'https://drive.google.com/file/d/1NW0tPojYoMICzVu9c0Qo1iEpgr9_CHpu/view?usp=drive_link'
    },
    {
        nombre:'Revisar Información y documentos a una solicitud',
        link:'https://drive.google.com/file/d/1qGX4-7Ac4kZ8DQkCiKxhVt5MjZ-hws3w/view?usp=sharing'
    },
    {
        nombre:'Enviar notificaciones a usuarios y cometarios de seguimiento',
        link:'https://drive.google.com/file/d/1Xq5Oq5LwjBg9yoliy4SCYmtkeQ5cMMk4/view?usp=sharing'
    },
    {
        nombre:'Enviar a corrección una solicitud a VA ',
        link:'https://drive.google.com/file/d/1yZqxyuXOlC5khKbpqotsZGB44MnNjDWK/view?usp=sharing'
    },
    {
        nombre:'Admitir una Solicitud',
        link:'https://drive.google.com/file/d/1AUL7z5c14OMciEwyopItXlD7810n8lpo/view?usp=sharing'
    },
]

export const videosGestiones: VideoTutorialesInterface[]=[
    {
        nombre:'Crear una Gestión desde Otras Fuentes',
        link:'https://drive.google.com/file/d/1R68OlOr7fFS9nyJFoarXggga1nS199De/view?usp=sharing'
    },
    {
        nombre:'Crear una gestión a partir de una existente',
        link:'https://drive.google.com/file/d/1gZA3aLLxWnaMC1a56XrGZKFTwbwD9b-I/view?usp=sharing'
    },
    {
        nombre:'Completar Gestiones de bienes asociados ',
        link:'https://drive.google.com/file/d/1RLoAksaPK4vE5GyPWk16WPfVbHRWsOzt/view?usp=sharing'
    },
    {
        nombre:'Completar Gestiones a partir de documentos Generados de bienes no asociados',
        link:'https://drive.google.com/file/d/1HvajTDz752DCeaOTYCisLRvkWXNInFAu/view?usp=sharing'
    },
    {
        nombre:'Completar Gestiones desde Otras Fuentes',
        link:'https://drive.google.com/file/d/19Krzf_Pwz_niepW93FrFnZ3XbC35ELpo/view?usp=sharing'
    },
]

export const videosBienesCulturales: VideoTutorialesInterface[] = [
    {
        nombre: "Registrar Bienes Culturales",
        link: "https://drive.google.com/file/d/1rcoMtGNVqShuMIW_9r1-6gmoznILvIh_/view?usp=sharing"
    },
    {
        nombre: "Emitir y Certificar una Ficha de Registro",
        link: "https://drive.google.com/file/d/15am0iwHrkIi760NXmx6Kq0B44VPBc_nr/view?usp=sharing"
    },
    {
        nombre: "Crear Coleccionista",
        link: "https://drive.google.com/file/d/1q5KUOisARsx8gQd43yo4Wt66AiBVs4sQ/view?usp=sharing"
    },
    {
        nombre: "Editar y Eliminar un Coleccionista",
        link: "https://drive.google.com/file/d/1KEQ5xlSgtsraEd6yzt5XXgzx_VvIUFUS/view?usp=sharing"
    },
    {
        nombre: "Traspaso de Coleccionistas",
        link: "https://drive.google.com/file/d/1uIiCzlHpTdKHM9DEB9hQl4cs_nJvapRx/view?usp=sharing"
    },
    {
        nombre: "Agregar desmembración o fraccionamiento a un bien cultural",
        link: "https://drive.google.com/file/d/1dtTwRy2a0_pk0rHa1ewnKYTs8i6oaOy-/view?usp=sharing"
    },
    {
        nombre: "Agregar Elementos Conformantes",
        link: "https://drive.google.com/file/d/1W1bCU9IaIsj3Vj1WG3_lPOzkEAAaYN2J/view?usp=sharing"
    },
    {
        nombre: "Actualizar departamento y municipio a un bien cultural",
        link: "https://drive.google.com/file/d/1m65Mdlqxc5lkrg9NxRO600t56LhjGRv8/view?usp=sharing"
    },
    {
        nombre: "Actualizar colección",
        link: "https://drive.google.com/file/d/1kCcFnlZylaxtLPqRMbhuU2XrPk2GqV3L/view?usp=sharing"
    }
];

export const videosDocumentosOficiales: VideoTutorialesInterface[]=[
    {
        nombre:'Administrar Plantillas',
        link:'https://drive.google.com/file/d/1F1FMxRSY0810k2ylstksKsJaYEOVB4To/view?usp=sharing'
    },
    {
        nombre:'Emitir y certificar Documentos Oficiales',
        link:'https://drive.google.com/file/d/19UKeWylmDEfk-VH_dYgnHkMaJYH9Tru9/view?usp=sharing'
    },
]

export const videosReportes: VideoTutorialesInterface[]=[
    {
        nombre:'Descarga de Reportes',
        link:'https://drive.google.com/file/d/16tU6vNtjajEASbhXfQlN3SSLHnm4HSQb/view?usp=sharing'
    },
]
